module.exports = __webpack_public_path__ + "static/media/Calendar.b446733e.svg";